import { render, staticRenderFns } from "./TourNote.vue?vue&type=template&id=7472bd96"
import script from "./TourNote.vue?vue&type=script&lang=js"
export * from "./TourNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports